// extracted by mini-css-extract-plugin
export default {"gutter":"Gutter_gutter__7t2G+","container":"Gutter_container__aG2sU"};